var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel", attrs: { id: "panel-4" } },
    [
      _c(
        "div",
        { staticClass: "panel-hdr bg-danger-800 bg-success-gradient" },
        [
          _c("h2", [
            _vm._v("\n                " + _vm._s(_vm.__t("LIST")) + " "),
            _c("span", { staticClass: "fw-300" }, [
              _c("i", [_vm._v(_vm._s(_vm.__t("NEWS_GROUPS")))]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "panel-toolbar" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed",
                on: { click: _vm.add_group },
              },
              [_c("i", { staticClass: "fal fa-plus" })]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "panel-container show pt-1 pb-1" }, [
        _c(
          "div",
          { staticClass: "panel-content" },
          [
            _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
              _c("div", { staticClass: "rounded" }, [
                _vm.worked_groups.length > 0
                  ? _c(
                      "ul",
                      { staticClass: "nav-menu mb-sm-4 mb-md-0 rounded" },
                      _vm._l(_vm.worked_groups, function (group) {
                        return _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "waves-effect waves-themed",
                              class: {
                                active_filter: _vm.is_active_item(group),
                              },
                              attrs: { href: "#" },
                            },
                            [
                              group.state
                                ? _c(
                                    "strong",
                                    {
                                      staticClass:
                                        "dl-ref bg-success-500 hidden-sm-down",
                                      on: {
                                        click: function ($event) {
                                          if (
                                            $event.target !==
                                            $event.currentTarget
                                          ) {
                                            return null
                                          }
                                          return _vm.setActive(group)
                                        },
                                      },
                                    },
                                    [_vm._v("active")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !group.state
                                ? _c(
                                    "strong",
                                    {
                                      staticClass: "dl-ref bg-danger-500",
                                      on: {
                                        click: function ($event) {
                                          if (
                                            $event.target !==
                                            $event.currentTarget
                                          ) {
                                            return null
                                          }
                                          return _vm.setActive(group)
                                        },
                                      },
                                    },
                                    [_vm._v("active")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "nav-link-text color-black",
                                  on: {
                                    click: function ($event) {
                                      if (
                                        $event.target !== $event.currentTarget
                                      ) {
                                        return null
                                      }
                                      return _vm.setActive(group)
                                    },
                                  },
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      { staticClass: "position-relative" },
                                      [
                                        _vm._v(
                                          "\n                                                " +
                                            _vm._s(_vm.__t(group.title)) +
                                            "\n                                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      group.group_type.length > 0
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "small badge border border-primary text-primary",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                        " +
                                                  _vm._s(
                                                    _vm.__t(
                                                      "PWA_NEWS." +
                                                        group.group_type.toUpperCase()
                                                    )
                                                  ) +
                                                  "\n                                                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fal fa-cog width-2 fs-xxl ml-4",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.edit(group)
                                  },
                                },
                              }),
                            ]
                          ),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass:
                    "filter-message js-filter-message m-0 text-left pl-4 py-3 fw-500",
                }),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("group_modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }